import {
  BankOutlined,
  BarChartOutlined,
  RetweetOutlined,
  StarOutlined,
  SwapOutlined,
  WalletOutlined,
} from '@app/components/icons'
import { MenuProps } from '@app/types'
import MenuItem from 'antd/es/menu/MenuItem'

import { AmericanFlagIcon, CoastIcon } from '~public'

type MenuItem = Required<MenuProps>['items'][number]

const HexMenuIcon = () => (
  <span className="anticon" role="img" aria-label="HEX">
    <img
      src="/images/hex-icon.png"
      alt=""
      width={16}
      height={16}
      style={{ width: 16, height: 16, objectFit: 'contain', display: 'block' }}
    />
  </span>
)

const LockEarnMenuIcon = () => (
  <span className="anticon" role="img" aria-label="L-Earn">
    <CoastIcon style={{ height: 16, width: 16, display: 'block' }} />
  </span>
)

export const ITEMS = [
  {
    icon: <AmericanFlagIcon style={{ height: 20, width: 20 }} />,
    key: '3',
    label: 'USD',
  },
  {
    icon: <BankOutlined />,
    key: 'deposit-and-withdraw',
    label: 'Deposit / Withdraw',
    route: '/deposit-and-withdraw',
  },
  /*{
    icon: <DollarOutlined />,
    key: '4',
    label: 'Mint / Burn',
    route: '/mint-and-burn',
  },*/
  {
    icon: <WalletOutlined />,
    key: 'buy',
    label:
    /*(
      <>
        <Text style={{ color: '#d7d7d7' }}>Buy / Sell</Text>
        <Text style={{ color: '#d7d7d7', marginLeft: '45px', marginRight: '5px' }}>New</Text>
        <FireOutlined style={{ color: '#D8382B' }} />
      </>
    )*/ 'Buy / Sell',
    route: '/buy-and-sell',
  },
  {
    icon: <HexMenuIcon />,
    key: 'hex',
    label: 'HEX',
    route: '/hex',
  },
  {
    icon: <BarChartOutlined />,
    key: 'portfolio',
    label: 'Portfolio',
    route: '/portfolio',
  },
  {
    icon: <LockEarnMenuIcon />,
    key: 'l-earn',
    label: 'L-Earn',
    route: '/l-earn',
  },
  {
    icon: <RetweetOutlined />,
    key: 'swap',
    label: 'Swap',
    route: '/swap',
  },
  {
    icon: <SwapOutlined />,
    key: 'transactions',
    label: 'Transactions',
    route: '/transactions',
  },
  /*{
    icon: <BarChartOutlined />,
    key: 'analytics',
    label: 'Analytics',
    route: '/analytics',
  },
  {
    icon: <UserOutlined />,
    key: '/profile',
    label: 'Profile',
    route: '/profile',
  },
  {
    icon: <SettingOutlined />,
    key: 'settings',
    label: 'Settings',
    route: '/settings',
  },*/
  {
    icon: <StarOutlined />,
    key: 'referrals',
    label: 'Refer a Friend',
    route: '/referrals',
  },
]

export const SIDEBAR_MENU_ITEMS = (onClick: (route: string) => void): MenuItem[] => {
  return ITEMS.map((item) => ({
    icon: item.icon,
    key: item.key,
    label: item.label,
    onClick: () => onClick(item.route),
  }))
}
